<perfect-scrollbar class="sidemenu">
  <div
    class="flex flex-column justify-between items-stretch"
    style="min-height: 100%"
  >
    <div>
      <div class="flex flex-column justify-start items-stretch">
        <cube-sidemenu-item
          *ngFor="let menu of menus"
          [menu]="menu"
          [iconOnly]="iconOnly"
        ></cube-sidemenu-item>
      </div>
    </div>
    <div>
      <div
        class="flex flex-column justify-end items-center"
        [style.margin]="'50px 0px 0px'"
      >
        <div *ngIf="!iconOnly">
          <a href="https://www.rina.org" target="_blank" title="RINA S.P.A.">
            <img width="75" src="./assets/rina/RINA-light.png" alt="RINA.org" />
          </a>
        </div>
        <div *ngIf="iconOnly">
          <a href="https://www.rina.org" target="_blank" title="RINA S.P.A.">
            <img width="50" src="./assets/rina/RINA-light.png" alt="RINA.org" />
          </a>
        </div>
        <div class="version">{{ version.version }}</div>
      </div>
    </div>
  </div>
</perfect-scrollbar>
